// Inbox-rooted prefix that all SLW internal routes hang off.
export const BASE_PATH = '/rental-manager/inbox';

export const MAX_OLD_CONVERSATION_DAYS = 660;

// Caps the inbox list's automatic catch-up pagination toward a deep-linked conversation; a very old
// lead could otherwise trigger an unbounded chain of page requests.
export const MAX_DEEP_LINKED_CONVERSATION_AUTO_FETCH_PAGES = 5;

export const SAVED_REPLY_TITLE_MAX_LENGTH = 80;
export const SAVED_REPLY_MESSAGE_MAX_LENGTH = 2000;

// Mirrors the rental-manager addMessage limit; the backend rejects longer sends with a 400
export const SEND_MESSAGE_MAX_LENGTH = 10000;

export default {
  BASE_PATH,
  MAX_DEEP_LINKED_CONVERSATION_AUTO_FETCH_PAGES,
  MAX_OLD_CONVERSATION_DAYS,
  SAVED_REPLY_TITLE_MAX_LENGTH,
  SAVED_REPLY_MESSAGE_MAX_LENGTH,
  SEND_MESSAGE_MAX_LENGTH,
};
